import URI from "urijs";
import store from "@/store";

(function flexible(window, document) {
  const setHtmlFontSize = (fontSize) => {
    docEl.style.fontSize = fontSize + "px";
    store.commit("SET_HTML_FONT_SIZE", fontSize);
  };
  //
  const href = window.location.href;
  if (href.includes("/intelligentAIWriting")) {
    let docEl = document.documentElement;
    docEl.style.fontSize = "1px";
    return;
  }
  //
  const { pc } = URI(window.location.href).query(true);
  let docEl = document.documentElement;
  let dpr = window.devicePixelRatio || 1;
  if (pc) {
    docEl.classList.add("pc");
    store.commit("SET_IS_PC", true);
  } else {
    docEl.classList.add("mobile");
    store.commit("SET_IS_MOBILE", true);
  }

  setHtmlFontSize(1);
  if (pc) {
    return;
  }

  // adjust body font size
  function setBodyFontSize() {
    if (document.body) {
      document.body.style.fontSize = 12 * dpr + "px";
    } else {
      document.addEventListener("DOMContentLoaded", setBodyFontSize);
    }
  }
  setBodyFontSize();

  // set 1rem = viewWidth / 10
  function setRemUnit() {
    let rem = Math.min(docEl.clientWidth, 677) / 788;
    setHtmlFontSize(rem);
  }

  setRemUnit();

  // reset rem unit on page resize
  window.addEventListener("resize", setRemUnit);
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) {
      setRemUnit();
    }
  });

  // detect 0.5px supports
  if (dpr >= 2) {
    let fakeBody = document.createElement("body");
    let testElement = document.createElement("div");
    testElement.style.border = ".5px solid transparent";
    fakeBody.appendChild(testElement);
    docEl.appendChild(fakeBody);
    if (testElement.offsetHeight === 1) {
      docEl.classList.add("hairlines");
    }
    docEl.removeChild(fakeBody);
  }
})(window, document);
